var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',_vm._l((_vm.vehicles.data),function(vehicle,index){return _c('b-col',{key:index,attrs:{"cols":"4"}},[_c('VehicleCard',{attrs:{"vehicle":vehicle}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }